import { h } from "preact";

import classname from "../../../../foundation/utils/classname";

import RichInput from "../../Input/RichInput";
import { InputVariant } from "../../Input";

import styles from "./RightPanelEditableBasicCell.module.css";

interface Props {
    class?: string;
    title: string;
    content: string;
    pattern: string;
    contentTitle?: string;
    description?: string;
    disabled: boolean;
    onBlur?: (event: Event) => void;
    onInput?: (event: Event) => void;
}

function RightPanelEditableBasicCell({
    class: cssClass,
    title,
    content,
    contentTitle,
    pattern,
    description,
    disabled,
    onBlur,
    onInput
}: Props) {
    return (
        <div class={classname(
            styles.rightPanelEditableBasicCell,
            cssClass
        )}>
            <span class={classname(styles.title, "body-1")}>{title}</span>
            <div class={styles.inputContainer}>
                <RichInput
                    class={styles.input}
                    value={content}
                    pattern={pattern}
                    variant={InputVariant.Ninja}
                    title={contentTitle}
                    disabled={disabled}
                    blurOnEnter
                    ellipsis
                    onBlur={onBlur}
                    onInput={onInput}/>
                {description && (
                    <div class={classname(styles.description, "caption-2", "ellipsis")}>
                        <span>{description}</span>
                    </div>
                )}
            </div>
        </div>
    );
}

export default RightPanelEditableBasicCell;
